import { lights } from "./Experience"

export class DeviceStateManager {
  constructor() {
    this.state = "desktop"
  }

  checkForInitialState() {
    //Check for touch device
    if ("ontouchstart" in document.documentElement) {
      this.state = "mobile"
    }

    setTimeout(() => {
      if (this.state === "mobile") {
        // lights.pointLight1.color.set(0x00ff00)
        // console.log("device is mobile")
      } else {
        // lights.pointLight1.color.set(0x0000ff)
        // console.log("device is desktop")
      }
    }, 2000)
  }
}
